import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPagePieChart: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPagePieChart"><Path d="M21.5 17C21.5 18.2426 20.9963 19.3676 20.182 20.182C19.3676 20.9963 18.2426 21.5 17 21.5C14.5147 21.5 12.5 19.4853 12.5 17C12.5 14.5147 14.5147 12.5 17 12.5C19.4853 12.5 21.5 14.5147 21.5 17Z" stroke="currentColor" strokeLinecap="square"/><Path d="M10.5 21.5H4.5V2.5H19.5V9.5" stroke="currentColor" strokeLinecap="square"/><Path d="M17 12.75V17L20 20" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPagePieChart;
